/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface CategoryField
 */
export interface CategoryField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof CategoryField
     */
    value: string;
}

/**
 * Check if a given object implements the CategoryField interface.
 */
export function instanceOfCategoryField(value: object): value is CategoryField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CategoryFieldFromJSON(json: any): CategoryField {
    return CategoryFieldFromJSONTyped(json, false);
}

export function CategoryFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function CategoryFieldToJSON(value?: CategoryField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

